export class PortalStatsService {
  constructor(context) {
    this.context = context;
    this.axios = this.context.$axios;
  }
  async GetSummaryStats({
    subscriberId,
    businessUnitId,
    toDate,
    fromDate,
    customerId,
    commercialName
  }) {
    try {
      const summaryStatsBySubscriber = await this.axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/portal-stats/summary?toDate=${toDate}&fromDate=${fromDate}&businessUnitId=${businessUnitId}&subscriberId=${subscriberId}&customerId=${customerId}&commercialName=${commercialName}`
      );

      return summaryStatsBySubscriber.data;
    } catch (err) {
      console.log(err);
    }
  }

  async GetItemsStats({ subscriberId, productId, fromDate, toDate }) {
    try {
      const itemsStats = await this.axios.get(
        `${
          process.env.VUE_APP_API_BASE_URL
        }/portal-stats/${productId}/businesses/${localStorage.getItem(
          "businessUnitId"
        )}/subscribers/${subscriberId}/items?fromDate=${fromDate}&toDate=${toDate}`
      );
      return itemsStats.data;
    } catch (err) {
      console.log(err);
    }
  }
}
